import { ArrayMinSize, IsArray, IsEnum, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { DayOfWeek } from './day-of-week.enum';

export class CreateCleaningAreaDto {
  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsString()
  @IsNotEmpty()
  icon!: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  description?: string;

  @IsArray()
  @ArrayMinSize(1)
  @IsEnum(DayOfWeek, { each: true })
  scheduledDays!: DayOfWeek[];

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  products?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  procedure?: string;
}
